export default __webpack_public_path__ + "static/waqas-8fbf6eca177b05d5da8fccc6da7a767a.png";